(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mt-cart-rewards"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mt-cart-rewards')) return;

  let revision = 0;
  let timer;
  let pending;
  const bars = () => Array.from(document.querySelectorAll('mt-cart-rewards'));
  const sectionOf = (element) => {
    try {
      return JSON.parse(element.querySelector('[data-reward-config]').textContent).sectionId || '';
    } catch {
      return '';
    }
  };
  const nativeSections = () => new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), (element) => element.dataset.sectionId));
  const stale = (element) => {
    element.hidden = true;
    element.setAttribute('data-reward-stale', '');
  };

  function applySections(sections) {
    const parsed = new Map();
    const updated = new Set();
    for (const element of bars()) {
      const id = sectionOf(element);
      if (!id || !Object.prototype.hasOwnProperty.call(sections, id)) continue;
      if (!parsed.has(id)) {
        const html = sections[id];
        const fragment = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : null;
        parsed.set(id, fragment && Array.from(fragment.querySelectorAll('mt-cart-rewards')).find((candidate) => sectionOf(candidate) === id));
      }
      const replacement = parsed.get(id);
      if (!replacement) stale(element);
      else {
        updated.add(id);
        if (element.outerHTML !== replacement.outerHTML) element.replaceWith(replacement.cloneNode(true));
      }
    }
    return updated;
  }

  async function refresh(ids, version) {
    if (version !== revision) return;
    const controller = new AbortController();
    pending = controller;
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      for (let offset = 0; offset < ids.length; offset += 5) {
        const batch = ids.slice(offset, offset + 5);
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', batch.join(','));
        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('section_request_failed');
        const sections = await response.json();
        if (version !== revision || controller.signal.aborted) return;
        const result = {};
        for (const id of batch) result[id] = sections?.[id] ?? null;
        applySections(result);
      }
    } catch {
      if (version === revision) {
        for (const element of bars()) if (ids.includes(sectionOf(element))) stale(element);
      }
    } finally {
      clearTimeout(timeout);
      if (pending === controller) pending = null;
    }
  }

  function update(event, force = false) {
    const version = ++revision;
    clearTimeout(timer);
    pending?.abort();
    const sections = event?.detail?.data?.sections || event?.detail?.resource?.sections || {};
    queueMicrotask(() => {
      if (version !== revision) return;
      const updated = applySections(sections);
      const owned = force ? new Set() : nativeSections();
      const ids = [...new Set(bars().map(sectionOf).filter((id) => id && !owned.has(id) && !updated.has(id)))];
      if (ids.length) timer = setTimeout(() => refresh(ids, version), 120);
    });
  }

  document.addEventListener('cart:update', update);
  document.addEventListener('discount:update', update);
  window.addEventListener('pageshow', (event) => { if (event.persisted) update(null, true); });
  customElements.define('mt-cart-rewards', class extends HTMLElement {});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-localization-switch"] && !Shopify.designMode) return;
  try {
    (() => {
    const preferenceKey = 'mt-localization-manual';
    const remember = () => {
      try {
        localStorage.setItem(preferenceKey, '1');
      } catch (error) {}
    };
    const openMenus = () => document.querySelectorAll('[data-mt-localization][open]');

    /* Auto-submit for [data-mt-localization-choice] selects (cart delivery country in mt-cart-rewards). */
    document.addEventListener('change', (event) => {
      const select = event.target.closest?.('[data-mt-localization-choice]');
      if (!select) return;
      remember();
      select.form?.submit();
    });

    document.addEventListener('click', (event) => {
      const option = event.target.closest?.('[data-mt-language-choice]');
      if (option) {
        if (option.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          const details = option.closest('[data-mt-localization]');
          if (details) {
            details.removeAttribute('open');
            details.querySelector('summary')?.focus();
          }
          return;
        }
        remember();
      }
      openMenus().forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      const open = [...openMenus()];
      if (!open.length) return;
      if (event.key === 'Escape') {
        open.forEach((details) => {
          const hadFocus = details.contains(document.activeElement);
          details.removeAttribute('open');
          if (hadFocus) details.querySelector('summary')?.focus();
        });
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const details = open.find((item) => item.contains(document.activeElement));
      if (!details) return;
      const options = [...details.querySelectorAll('[data-mt-language-choice]')];
      if (!options.length) return;
      event.preventDefault();
      const step = event.key === 'ArrowDown' ? 1 : -1;
      const index = options.indexOf(document.activeElement);
      const next = index === -1 ? (step > 0 ? 0 : options.length - 1) : (index + step + options.length) % options.length;
      options[next].focus();
    });

    document.addEventListener('focusin', (event) => {
      openMenus().forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-newsletter-direct"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-newsletter-direct')) {
    // Code BIENVENUE10 invisible après l'inscription (enquête du 23/10) : il n'apparaissait qu'au retour de Shopify avec
    // « ?customer_posted=true » (et l'ancre, pour le pop-up). Le détour anti-robots, un onglet quitté pendant l'envoi ou une
    // adresse déjà connue le faisaient perdre sans bruit. Ici, l'envoi est intercepté AVANT hCaptcha (phase de capture sur
    // window), l'adresse part au serveur OVH, et le code s'affiche dès sa réponse « ok ». Sinon : envoi natif, comme avant.
    const PENDING_KEY = 'mtnl_pending_v1';
    const CONFIRMED_KEY = 'mtnl_native_confirmed_v2';
    const SERVER_TIMEOUT = 4000;
    const CAPTCHA_WAIT = 6000;
    // Le serveur n'en tient compte que pour une adresse @example.com : pour toute autre adresse, c'est une vraie inscription.
    const essai = /[?&]mtnl_essai=1(?:&|$)/.test(location.search);
    const ESSAI_ADRESSE = /@example\.com$/i;
    const attempt = action => { try { return action(); } catch (_) { return null; } };
    const reducedMotion = () => attempt(() => matchMedia('(prefers-reduced-motion: reduce)').matches) === true;
    const markerOf = form => {
      const marker = form?.querySelector?.('mt-newsletter-direct');
      return marker && marker.closest('form') === form ? marker : null;
    };
    const emailInput = form => form.querySelector('input[type="email"][name="contact[email]"]');
    const notePending = form => attempt(() => sessionStorage.setItem(PENDING_KEY, JSON.stringify({ form: form.id, at: Date.now() })));
    const setSending = (form, on) => {
      form.toggleAttribute('data-mtnl-sending', on);
      if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
      form.querySelectorAll('[type="submit"]').forEach(button => { if (on) button.setAttribute('aria-disabled', 'true'); else button.removeAttribute('aria-disabled'); });
    };
    // Même règle que mt-newsletter-identity : identification Shopify seulement avec le consentement mesure ET marketing.
    const identify = email => attempt(() => {
      const privacy = window.Shopify?.customerPrivacy;
      const analytics = window.Shopify?.analytics;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || typeof privacy?.marketingAllowed !== 'function' || typeof analytics?.visitor !== 'function') return;
      if (privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true) analytics.visitor({ email });
    });
    const announce = (form, done) => {
      const live = form.querySelector('[data-mtnl-live]');
      if (!live || !done) return;
      const text = Array.from(done.querySelectorAll('[data-mtnl-say]'), element => element.textContent.trim()).filter(Boolean).join(' ');
      live.textContent = '';
      setTimeout(() => { live.textContent = text; }, 80);
    };
    // Texte de consentement réellement affiché autour du champ (C2) et son empreinte SHA-256, gardée dans le journal du serveur.
    // innerText ne garde que le texte rendu : la mention masquée sur téléphone n'y est pas, la ligne courte du téléphone y est.
    const consentText = form => {
      const root = form.closest('[data-mtnl-consent]') || form;
      const text = String(root.innerText || root.textContent || '').replace(/\s+/g, ' ').trim();
      return Array.from(text).slice(0, 1500).join('');
    };
    const sha256 = text => Promise.resolve()
      .then(() => crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)))
      .then(buffer => Array.from(new Uint8Array(buffer), byte => byte.toString(16).padStart(2, '0')).join(''))
      .catch(() => '');
    // Une autre fenêtre est-elle ouverte (panier, menu, feuille du téléphone) ? Même liste que le pop-up.
    const OVERLAYS = 'dialog[open],.mtp-open,.mt-cfg.is-open,.mtmc.is-open,.musee-config.is-open,.mt-volet.mt-open,.mt-barre-feuille.on,[aria-modal="true"]:not(dialog):not([hidden])';
    const overlayOpen = () => Array.from(document.querySelectorAll(OVERLAYS)).some(element => element.getClientRects().length && element.getAttribute('aria-hidden') !== 'true' && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
    // Bords de l'écran couverts par des éléments fixes ou collants (en-tête, barre des catégories, bandeau cookies de Shopify,
    // barre du téléphone) : mesurés à chaque fois, jamais supposés (D1, D2).
    const insets = () => {
      const width = document.documentElement.clientWidth || window.innerWidth;
      const height = window.innerHeight;
      let top = 0;
      let bottom = 0;
      for (const element of document.body.getElementsByTagName('*')) {
        const style = getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') continue;
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) < 0.05 || style.pointerEvents === 'none') continue;
        const rect = element.getBoundingClientRect();
        if (rect.width < width * 0.5 || rect.height <= 0 || rect.height > height * 0.7 || rect.bottom <= 0 || rect.top >= height) continue;
        if (style.position === 'sticky') {
          const stuckTop = Math.abs(rect.top - parseFloat(style.top)) < 2;
          const stuckBottom = Math.abs(height - rect.bottom - parseFloat(style.bottom)) < 2;
          if (!stuckTop && !stuckBottom) continue;
        }
        if (rect.top < height * 0.4) top = Math.max(top, rect.bottom);
        else if (rect.bottom > height * 0.6) bottom = Math.max(bottom, height - rect.top);
      }
      return { top, bottom };
    };
    let userScrolledAt = 0;
    ['wheel', 'touchmove', 'keydown'].forEach(type => window.addEventListener(type, event => {
      if (type !== 'keydown' || /^(Arrow|Page|Home|End)|^ $/.test(event.key)) userScrolledAt = Date.now();
    }, { capture: true, passive: true }));
    // Amène le bloc du code (code, Copier, « Utiliser mes −10 % ») entre les éléments fixes du haut et du bas de l'écran.
    // Pas de défilement s'il y est déjà. Nouvelle mesure 0,7 s et 1,6 s plus tard (défilement doux terminé, images ou en-tête
    // qui bougent), sauf si le visiteur a lui-même fait défiler. Une autre fenêtre ouverte : on attend qu'elle se ferme (C8).
    let viewTimer = 0;
    const bringIntoView = (element, smooth) => {
      clearTimeout(viewTimer);
      const started = Date.now();
      const passes = [0, 700, 1600];
      let pass = 0;
      const step = () => {
        if (!element?.isConnected || !element.getClientRects().length || userScrolledAt > started) return;
        if (overlayOpen()) { if (Date.now() - started < 60000) viewTimer = setTimeout(step, 500); return; }
        const { top, bottom } = insets();
        const high = top + 12;
        const low = window.innerHeight - bottom - 12;
        const rect = element.getBoundingClientRect();
        let delta = 0;
        if (rect.top < high || rect.height > low - high) delta = rect.top - high;
        else if (rect.bottom > low) delta = rect.bottom - low;
        if (Math.abs(delta) >= 2) window.scrollBy({ top: delta, behavior: smooth && pass === 0 && !reducedMotion() ? 'smooth' : 'auto' });
        pass += 1;
        if (pass < passes.length) viewTimer = setTimeout(step, passes[pass] - passes[pass - 1]);
      };
      step();
    };
    const focusCode = done => done?.querySelector('[data-mtnl-code-value]')?.focus({ preventScroll: true });
    // Lien « Utiliser mes −10 % » : absent du HTML de la page (pas d'adresse /discount/ à suivre pour un robot, C10), posé ici
    // au moment d'afficher le code. Après un envoi Shopify natif réussi, le thème le rend directement.
    const armUse = scope => scope?.querySelectorAll('a[data-mtnl-use]').forEach(link => {
      if (link.getAttribute('href') || !link.dataset.code) return;
      link.setAttribute('href', '/discount/' + encodeURIComponent(link.dataset.code) + '?redirect=' + encodeURIComponent(link.dataset.redirect || '/'));
    });
    // Affiche la partie « done » du formulaire. Le pop-up gère lui-même ses étapes (il annule l'événement mtnl:code).
    const showCode = form => {
      armUse(form);
      const event = new CustomEvent('mtnl:code', { bubbles: true, cancelable: true });
      form.dispatchEvent(event);
      if (!event.defaultPrevented) form.querySelectorAll('[data-mtnl-part]').forEach(part => { part.hidden = part.dataset.mtnlPart !== 'done'; });
      const done = form.querySelector('[data-mtnl-part="done"],[data-mtnl-step="done"]');
      // 0,32 s : le clavier du téléphone se referme (le champ vient de perdre le focus) avant la mesure de l'écran.
      if (!event.defaultPrevented) { focusCode(done); setTimeout(() => bringIntoView(done, true), 320); }
      announce(form, done);
    };
    const succeed = (form, email, data) => {
      setSending(form, false);
      attempt(() => localStorage.setItem(CONFIRMED_KEY, 'subscribed'));
      attempt(() => sessionStorage.removeItem(PENDING_KEY));
      identify(email);
      emailInput(form)?.blur();
      showCode(form);
      // C9 : l'envoi direct est arrêté avant l'événement Shopify « form_submitted » : on publie le nôtre pour les pixels.
      if (data?.essai !== true) attempt(() => window.Shopify?.analytics?.publish?.('mt_newsletter_signup', { source: markerOf(form)?.dataset.source || 'autre' }));
      document.dispatchEvent(new CustomEvent('mtnl:subscribed'));
    };
    // v3 (N1) : mode essai (?mtnl_essai=1) avec une adresse @example.com et réponse non « ok » (refus, plafond, panne, délai).
    // Le repli Shopify créerait un VRAI client « example.com » : il n'a pas lieu, un message d'essai le remplace sous le
    // formulaire. Toute autre adresse garde le repli (un vrai client qui suit un lien ?mtnl_essai=1 doit pouvoir s'inscrire).
    const essaiSansRepli = (form, detail) => {
      setSending(form, false);
      const part = form.querySelector('[data-mtnl-step="form"],[data-mtnl-part="form"]') || form;
      let note = form.querySelector('[data-mtnl-essai-note]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-mtnl-essai-note', '');
        note.setAttribute('role', 'status');
        note.setAttribute('lang', 'fr');
        note.style.cssText = 'margin:10px 0 0;padding:8px 10px;border:1px dashed currentColor;border-radius:8px;font-size:13px;line-height:1.4;text-align:left';
        part.append(note);
      }
      note.textContent = 'Mode essai : le serveur n’a pas répondu « ok » (' + (detail || 'réponse illisible') + '). Rien n’est envoyé au formulaire Shopify pour une adresse @example.com.';
      console.warn('mtnl essai : réponse non « ok », pas de repli Shopify (' + (detail || '?') + ')');
    };
    // Repli : l'envoi Shopify d'origine, protégé par hCaptcha. requestSubmit() relance l'événement submit, que le script
    // captcha-bootstrap de Shopify et son fournisseur traitent comme avant (jeton invisible, puis envoi).
    const submitNatively = form => {
      // C7 : à partir d'ici, plus aucun appel au serveur pour cette saisie ; un nouvel Entrée va droit à l'envoi Shopify.
      form.dataset.mtnlRepli = '1';
      const started = Date.now();
      const captcha = !!window.Shopify?.captcha;
      if (captcha && !form.dataset.cptcha) emailInput(form)?.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      const go = () => {
        if (!form.isConnected) return;
        const bound = form.hasAttribute('data-hcaptcha-bound');
        if (captcha && !bound && Date.now() - started < CAPTCHA_WAIT) { setTimeout(go, 150); return; }
        setSending(form, false);
        if (bound || !captcha) {
          form.dataset.mtnlNative = '1';
          if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
          delete form.dataset.mtnlNative;
          notePending(form);
          form.submit();
          return;
        }
        // hCaptcha jamais prêt (bloqué, réseau) : envoi sans jeton ; Shopify fera passer par sa page anti-robots.
        notePending(form);
        HTMLFormElement.prototype.submit.call(form);
      };
      go();
    };
    window.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const marker = markerOf(form);
      if (!marker) return;
      if (form.dataset.mtnlNative === '1') { delete form.dataset.mtnlNative; notePending(form); return; }
      if (form.hasAttribute('data-mtnl-sending')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      // C7 : repli déjà engagé (serveur muet ou en panne, hCaptcha en cours) : l'envoi Shopify suit son cours, sans le serveur.
      if (form.dataset.mtnlRepli === '1') { notePending(form); return; }
      const input = emailInput(form);
      const email = (input?.value || '').trim();
      const endpoint = marker.dataset.endpoint || '';
      if (!email || !input.checkValidity() || !/^https:\/\//.test(endpoint) || typeof fetch !== 'function' || typeof AbortController !== 'function') {
        if (email) notePending(form);
        return;
      }
      // Avant hCaptcha et avant tout autre écouteur : sinon le fournisseur hCaptcha renverrait le formulaire lui-même.
      event.preventDefault();
      event.stopImmediatePropagation();
      setSending(form, true);
      const controller = new AbortController();
      form.mtnlRequest = { controller, abandoned: false };
      const request = form.mtnlRequest;
      const timer = setTimeout(() => controller.abort(), SERVER_TIMEOUT);
      let detail = '';
      const ct = consentText(form);
      sha256(ct)
        .then(cv => {
          const body = { email, source: marker.dataset.source || 'autre', lang: marker.dataset.lang || 'fr', hp: form.querySelector('[data-mtnl-hp]')?.value || '', cv, ct };
          if (essai) body.essai = true;
          return fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), signal: controller.signal });
        })
        .then(response => { detail = 'HTTP ' + response.status; return response.ok ? response.json() : null; })
        .catch(error => { if (!detail) detail = error?.name === 'AbortError' ? 'pas de réponse en 4 s' : 'réseau'; return null; })
        .then(data => {
          clearTimeout(timer);
          if (form.mtnlRequest === request) form.mtnlRequest = null;
          // Page quittée (ou mise en cache) pendant l'attente : rien ne part au retour ; le formulaire est remis à zéro.
          if (request.abandoned) return;
          if (data && data.ok === true) { try { succeed(form, email, data); } catch (error) { console.error(error); } }
          // v3 (N1) : jamais de repli Shopify en mode essai pour une adresse @example.com (il créerait un vrai client).
          else if (essai && ESSAI_ADRESSE.test(email)) essaiSansRepli(form, detail);
          else submitNatively(form);
        });
    }, true);
    window.addEventListener('pagehide', () => {
      document.querySelectorAll('form[data-mtnl-sending]').forEach(form => {
        if (!form.mtnlRequest) return;
        form.mtnlRequest.abandoned = true;
        form.mtnlRequest.controller.abort();
      });
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      document.querySelectorAll('mt-newsletter-direct').forEach(marker => {
        const form = marker.closest('form');
        if (!form) return;
        setSending(form, false);
        delete form.dataset.mtnlRepli;
        delete form.dataset.mtnlNative;
      });
    });
    // Bouton « Copier » de tous les formulaires : presse-papiers, puis copie à l'ancienne, puis sélection du code.
    const copyWithTextarea = (text, host) => {
      const area = document.createElement('textarea');
      area.value = text;
      area.readOnly = true;
      area.tabIndex = -1;
      area.setAttribute('aria-hidden', 'true');
      area.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px';
      host.append(area);
      let copied = false;
      try { area.focus({ preventScroll: true }); area.select(); area.setSelectionRange(0, text.length); copied = document.execCommand('copy') === true; } catch (_) {}
      area.remove();
      return copied;
    };
    const selectText = element => attempt(() => {
      const range = document.createRange();
      range.selectNodeContents(element);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    });
    document.addEventListener('click', async event => {
      const button = event.target.closest?.('[data-mtnl-copy]');
      if (!button) return;
      const scope = button.closest('form') || button.parentElement;
      const codeElement = scope?.querySelector('[data-mtnl-code-value]');
      const status = scope?.querySelector('[data-mtnl-copy-status]');
      const code = (button.dataset.code || codeElement?.textContent || '').trim();
      if (!code) return;
      let copied = false;
      if (typeof navigator.clipboard?.writeText === 'function') { try { await navigator.clipboard.writeText(code); copied = true; } catch (_) {} }
      if (!copied) copied = copyWithTextarea(code, button.closest('dialog') || document.body);
      if (button.isConnected) button.focus({ preventScroll: true });
      if (!copied && codeElement) selectText(codeElement);
      button.toggleAttribute('data-copied', copied);
      if (status) {
        status.textContent = '';
        setTimeout(() => { status.textContent = copied ? button.dataset.copied || '' : button.dataset.copyError || ''; }, 40);
      }
    });
    customElements.define('mt-newsletter-direct', class extends HTMLElement {
      // Retour d'un envoi natif réussi (bande du pied de page, encart de l'accueil) : abonné noté, code mis au premier plan.
      connectedCallback() {
        const form = this.closest('form');
        const done = form?.querySelector('[data-mtnl-native-ok]');
        if (!done || done.hidden) return;
        armUse(form);
        attempt(() => localStorage.setItem(CONFIRMED_KEY, 'subscribed'));
        document.dispatchEvent(new CustomEvent('mtnl:subscribed'));
        if (location.hash !== '#' + form.id) return;
        // D1 : après le chargement (le défilement du navigateur vers l'ancre #formulaire est alors fait, et il retirait le
        // focus posé trop tôt), focus sur le code et bloc ramené entre l'en-tête et le bas de l'écran, mesurés.
        const go = () => setTimeout(() => { focusCode(done); bringIntoView(done, false); }, 60);
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-newsletter-identity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-newsletter-identity')) {
    const storageKey = 'mt_newsletter_identity_pending_v1';
    const lifetime = 10 * 60 * 1000;
    const retryDelays = [250, 500, 1000, 2000, 3000, 4000];
    let confirmed = null;
    let retryTimer = null;
    let expiryTimer = null;
    let retryCount = 0;
    let privacyRequested = false;

    const refreshCookieControls = () => {
      const available = typeof window.privacyBanner?.showPreferences === 'function';
      document.querySelectorAll('[data-mt-cookie-preferences]').forEach(button => { button.hidden = !available; });
    };
    document.addEventListener('click', async event => {
      const button = event.target.closest?.('[data-mt-cookie-preferences]');
      if (!button || button.hidden || button.disabled) return;
      if (typeof window.privacyBanner?.showPreferences !== 'function') { refreshCookieControls(); return; }
      const dialog = button.closest('dialog');
      const popup = button.closest('mt-newsletter-popup');
      button.disabled = true;
      try {
        if (dialog?.open && typeof dialog.close === 'function') {
          await new Promise(resolve => {
            dialog.addEventListener('close', resolve, { once: true });
            dialog.close();
          });
        }
        await window.privacyBanner.showPreferences();
      } catch (_) {
        if (popup && !dialog?.open && typeof popup.open === 'function') popup.open(popup.previousFocus);
      } finally { button.disabled = false; }
    });
    document.addEventListener('load', refreshCookieControls, true);
    window.addEventListener('load', refreshCookieControls);
    document.addEventListener('focusin', refreshCookieControls);
    const setState = (record, state) => {
      const marker = record && document.getElementById(record.formId)?.querySelector('mt-newsletter-identity');
      if (marker?.dataset.formId === record?.formId) marker.dataset.mtIdentityState = state;
    };
    const blockAll = () => { document.querySelectorAll('mt-newsletter-identity').forEach(marker => { marker.dataset.mtIdentityState = 'blocked'; }); };
    const clearStored = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
    const stop = () => {
      clearTimeout(retryTimer);
      clearTimeout(expiryTimer);
      retryTimer = null;
      expiryTimer = null;
      confirmed = null;
      retryCount = 0;
    };
    const purge = () => { clearStored(); stop(); };
    const permission = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || typeof privacy?.marketingAllowed !== 'function') return null;
      try { return privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true; }
      catch (_) { return null; }
    };
    const validRecord = record => {
      if (!record || record.version !== 1 || typeof record.email !== 'string' || record.email.length > 254 || !/^[^\s@]+@[^\s@]+$/.test(record.email)) return false;
      if (typeof record.formId !== 'string' || !record.formId || record.formId.length > 240) return false;
      if (typeof record.path !== 'string' || !record.path.startsWith('/') || record.path.length > 2048) return false;
      if (typeof record.hash !== 'string' || record.hash !== '#' + record.formId) return false;
      return Number.isFinite(record.createdAt) && record.createdAt <= Date.now() && Date.now() - record.createdAt < lifetime;
    };
    const readStored = () => {
      try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw) return null;
        const record = JSON.parse(raw);
        if (validRecord(record)) return record;
      } catch (_) {}
      clearStored();
      return null;
    };
    const returnState = record => {
      if (/(^|\/)challenge(?:\/|$)/.test(location.pathname)) return 'challenge';
      if (record.path !== location.pathname || record.hash !== location.hash) return 'mismatch';
      const form = document.getElementById(record.formId);
      const marker = form?.querySelector('mt-newsletter-identity');
      if (!marker && document.readyState === 'loading') return 'waiting';
      if (!marker || marker.closest('form') !== form || marker.dataset.formId !== record.formId || marker.dataset.returnPath !== record.path) return 'mismatch';
      return marker.dataset.result;
    };
    const loadPrivacy = () => {
      if ((typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' && typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') || privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
      privacyRequested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) processPending();
        });
      } catch (_) {}
    };
    const retry = record => {
      if (retryTimer !== null) return;
      if (retryCount >= retryDelays.length) { setState(record, 'unavailable'); purge(); return; }
      retryTimer = setTimeout(() => { retryTimer = null; processPending(); }, retryDelays[retryCount++]);
    };
    const armExpiry = record => {
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(purge, Math.max(0, lifetime - (Date.now() - record.createdAt)));
    };
    function processPending() {
      refreshCookieControls();
      loadPrivacy();
      const allowed = permission();
      if (allowed === false) { blockAll(); purge(); return; }
      const record = confirmed || readStored();
      if (!record) { stop(); return; }
      if (!validRecord(record)) { purge(); return; }
      armExpiry(record);
      const state = returnState(record);
      if (state === 'challenge') return;
      if (state === 'waiting') { retry(record); return; }
      if (state !== 'success') { purge(); return; }
      if (allowed !== true) { retry(record); return; }
      if (!confirmed) {
        confirmed = record;
        clearStored();
      }
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.visitor !== 'function') { retry(record); return; }
      let accepted = false;
      try { accepted = analytics.visitor({ email: record.email }) === true; } catch (_) {}
      setState(record, accepted ? 'accepted' : 'unavailable');
      purge();
    }
    document.addEventListener('submit', event => {
      const form = event.target;
      const marker = form?.querySelector?.('mt-newsletter-identity');
      if (!marker || marker.closest('form') !== form || marker.dataset.formId !== form.id) return;
      purge();
      loadPrivacy();
      if (event.defaultPrevented || typeof form.checkValidity !== 'function' || !form.checkValidity()) return;
      if (permission() !== true) { marker.dataset.mtIdentityState = 'blocked'; return; }
      const input = form.querySelector('input[type="email"][name="contact[email]"]');
      if (!input || !input.checkValidity() || marker.dataset.returnPath !== location.pathname) return;
      let action;
      try { action = new URL(form.action, location.href); } catch (_) { return; }
      if (form.method.toLowerCase() !== 'post' || action.origin !== location.origin || !/(^|\/)contact$/.test(action.pathname) || action.hash !== '#' + form.id) return;
      const record = { version: 1, email: input.value.trim(), formId: form.id, path: location.pathname, hash: action.hash, createdAt: Date.now() };
      if (!validRecord(record)) return;
      try { sessionStorage.setItem(storageKey, JSON.stringify(record)); armExpiry(record); } catch (_) { purge(); }
    }, true);
    document.addEventListener('DOMContentLoaded', processPending);
    document.addEventListener('visitorConsentCollected', () => { if (permission() !== true) { blockAll(); purge(); } else processPending(); });
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', processPending);
    window.addEventListener('hashchange', processPending);
    customElements.define('mt-newsletter-identity', class extends HTMLElement {
      connectedCallback() { processPending(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-whatsapp-contact"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mt-whatsapp-contact')){
  customElements.define('mt-whatsapp-contact',class extends HTMLElement{
    connectedCallback(){
      this.cancelPending();
      this.stopDockAvoidance();
      this.controller?.abort();
      this.controller=new AbortController();
      this.busy=false;
      const options={signal:this.controller.signal};
      const launcher=this.querySelector('.mtwa-launcher'),dialog=this.querySelector('dialog'),form=this.querySelector('form'),phone=this.querySelector('[data-mtwa-phone]'),checkbox=this.querySelector('[data-mtwa-consent]'),link=this.querySelector('[data-mtwa-link]'),direct=this.querySelector('[data-mtwa-direct]'),submit=this.querySelector('[data-mtwa-submit]'),submitLabel=this.querySelector('[data-mtwa-submit-label]'),status=this.querySelector('[data-mtwa-status]'),phoneError=this.querySelector('[data-mtwa-phone-error]'),website=this.querySelector('[data-mtwa-website]');
      if(!launcher||!dialog||!form||!phone||!checkbox||!link||!direct||!submit||!status||!phoneError||!website)return;
      this.setupDockAvoidance(launcher);
      const whatsappUrl=consented=>'https://wa.me/33759702819?text='+encodeURIComponent(this.dataset.message+(consented?'\n\n'+this.dataset.consent:''));
      const setBusy=value=>{this.busy=value;phone.disabled=value;checkbox.disabled=value;submit.disabled=value;form.setAttribute('aria-busy',String(value));submitLabel.textContent=value?this.dataset.loading:this.dataset.openLabel;};
      const setStatus=(text,state)=>{status.textContent=text;status.dataset.state=state;status.hidden=!text;};
      const clearError=()=>{phone.setCustomValidity('');phone.removeAttribute('aria-invalid');phoneError.textContent='';phoneError.hidden=true;};
      const reset=()=>{form.hidden=false;form.reset();checkbox.checked=false;phone.value='';clearError();setBusy(false);setStatus('','');link.hidden=true;direct.hidden=true;link.href=whatsappUrl(false);direct.href=whatsappUrl(false);};
      reset();
      phone.addEventListener('input',clearError,options);
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(this.busy)return;
        clearError();
        const country=this.dataset.country||'FR';
        const raw=phone.value.trim();
        let normalized=raw.replace(/[ ().-]/g,'');
        if(normalized.startsWith('00'))normalized='+'+normalized.slice(2);
        if(country==='FR'&&/^0[67][0-9]{8}$/.test(normalized))normalized='+33'+normalized.slice(1);
        const valid=/^[+0-9 ().-]+$/.test(raw)&&raw.length<=40&&/^\+[1-9][0-9]{7,14}$/.test(normalized)&&(!normalized.startsWith('+33')||/^\+33[1-9][0-9]{8}$/.test(normalized));
        if(!valid){phone.setCustomValidity(this.dataset.errorPhone);phone.setAttribute('aria-invalid','true');phoneError.textContent=this.dataset.errorPhone;phoneError.hidden=false;phone.focus();form.reportValidity();return;}
        if(!form.reportValidity())return;
        if(website.value){setStatus(this.dataset.errorSave,'error');direct.hidden=false;return;}
        const selectedConsent=checkbox.checked===true;
        const destination=whatsappUrl(selectedConsent);
        const payload={phone:normalized,country,marketing_consent:selectedConsent,locale:this.dataset.locale==='en'?'en':'fr',source_path:window.location.pathname.slice(0,240),website:''};
        const generation=++this.generation;
        const requestController=new AbortController();
        this.pendingRequest=requestController;
        let pendingWindow=null;
        try{
          pendingWindow=window.open('about:blank','_blank');
          if(pendingWindow){pendingWindow.opener=null;pendingWindow.document.title=this.dataset.loading;pendingWindow.document.body.textContent=this.dataset.loading;}
        }catch(error){if(pendingWindow)try{pendingWindow.close();}catch(closeError){}pendingWindow=null;}
        this.pendingWindow=pendingWindow;
        setBusy(true);setStatus(this.dataset.loading,'loading');link.hidden=true;direct.hidden=true;
        const timer=setTimeout(()=>requestController.abort(),12000);
        try{
          const response=await fetch('https://admin.mytomette.fr/whatsapp-leads.php',{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:requestController.signal});
          const result=await response.json();
          if(generation!==this.generation||!this.isConnected)return;
          if(!response.ok||result.ok!==true||typeof result.contact_id!=='string'||!/^[a-f0-9]{32}$/.test(result.contact_id)){const error=new Error('capture_failed');error.rateLimited=response.status===429;throw error;}
          link.href=destination;link.hidden=false;direct.hidden=true;setStatus(this.dataset.success,'success');
          phone.value='';checkbox.checked=false;
          if(pendingWindow&&!pendingWindow.closed){try{pendingWindow.location.replace(destination);}catch(error){try{pendingWindow.close();}catch(closeError){}}}
          this.pendingWindow=null;
          submit.hidden=true;form.hidden=true;
          link.focus({preventScroll:true});
        }catch(error){
          if(pendingWindow)try{pendingWindow.close();}catch(closeError){}
          if(generation!==this.generation||!this.isConnected)return;
          this.pendingWindow=null;setStatus(error.rateLimited?this.dataset.errorRate:this.dataset.errorSave,'error');direct.hidden=false;
        }finally{
          clearTimeout(timer);
          if(generation===this.generation){this.pendingRequest=null;setBusy(false);if(status.dataset.state==='error')submitLabel.textContent=this.dataset.retry;}
        }
      },options);
      if(typeof dialog.showModal!=='function')return;
      launcher.setAttribute('aria-haspopup','dialog');
      launcher.setAttribute('aria-controls',dialog.id);
      launcher.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();this.cancelPending();reset();submit.hidden=false;dialog.showModal();},options);
      this.querySelector('.mtwa-close').addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();},options);
      dialog.addEventListener('close',()=>{this.cancelPending();reset();submit.hidden=false;launcher.focus({preventScroll:true});},options);
    }
    setupDockAvoidance(launcher){
      if(this.dataset.pageType!=='product'||typeof window.matchMedia!=='function')return;
      const root=document.documentElement;
      const media=window.matchMedia('(max-width:880px)');
      this.dockRoot=root;
      const activate=()=>{
        this.stopDockAvoidance();
        if(!media.matches)return;
        const controller=new AbortController();
        this.dockController=controller;
        const update=()=>{
          this.dockFrame=0;
          const gap=parseFloat(getComputedStyle(root).getPropertyValue('--mt-dock-gap'))||8;
          const docks=[launcher,...document.querySelectorAll('mt-newsletter-popup .mtnl-bubble:not([hidden])')].map(element=>element.getBoundingClientRect()).filter(rect=>rect.width>0&&rect.height>0);
          const overlaps=Array.from(document.querySelectorAll('.mtx-photo-cta,#mtpAdd.mtp-cta,.mtx-bouton')).some(cta=>{
            if(cta.closest('#mtpFlot,.mtp-flot,.musee-sticky,.photo-floating,.sticky-add-to-cart__bar,dialog,[aria-modal="true"]'))return false;
            const rect=cta.getBoundingClientRect();
            if(!rect.width||!rect.height||!docks.some(dock=>rect.left<dock.right+gap&&rect.right>dock.left-gap&&rect.top<dock.bottom+gap&&rect.bottom>dock.top-gap))return false;
            for(let element=cta;element&&element!==root;element=element.parentElement){
              const style=getComputedStyle(element);
              if(style.position==='fixed'||style.position==='sticky'||style.display==='none'||style.visibility==='hidden'||Number(style.opacity)===0)return false;
            }
            return true;
          });
          root.toggleAttribute('data-mt-dock-cta-overlap',overlaps);
        };
        const schedule=()=>{if(!this.dockFrame)this.dockFrame=requestAnimationFrame(update);};
        const options={passive:true,signal:controller.signal};
        window.addEventListener('scroll',schedule,options);
        window.addEventListener('resize',schedule,options);
        window.visualViewport?.addEventListener('scroll',schedule,options);
        window.visualViewport?.addEventListener('resize',schedule,options);
        document.addEventListener('load',schedule,{...options,capture:true});
        document.addEventListener('DOMContentLoaded',schedule,{...options,once:true});
        update();
      };
      media.addEventListener('change',activate,{signal:this.controller.signal});
      activate();
    }
    stopDockAvoidance(){
      this.dockController?.abort();
      this.dockController=null;
      if(this.dockFrame)cancelAnimationFrame(this.dockFrame);
      this.dockFrame=0;
      this.dockRoot?.removeAttribute('data-mt-dock-cta-overlap');
    }
    cancelPending(){this.generation=(this.generation||0)+1;this.pendingRequest?.abort();this.pendingRequest=null;if(this.pendingWindow)try{this.pendingWindow.close();}catch(error){}this.pendingWindow=null;}
    disconnectedCallback(){this.cancelPending();this.stopDockAvoidance();this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
